import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import profile from "../assets/images/profile.png";
import logo from "../assets/images/logo_cyber_112.png";

const CyberAwarenessBusinessIntro = () => {
    const navigate = useNavigate();
    const [userData, setUserData] = useState({ first_name: "", last_name: "", username: "", score: 0, rank: 4, completion: "10%", days: 0 });
    const rawUserId = localStorage.getItem("userId");
    const userId = rawUserId && rawUserId !== "null" ? parseInt(rawUserId, 10) : null;
    const [maxScore, setMaxScore] = useState(0);
    const [maxSectionsNum, setMaxSectionsNum] = useState(1);
    const [sectionId, setSectionId] = useState(1);
    const [screenId, setScreenId] = useState(1);
    console.log("Dohvaćeni userId:", userId);

    useEffect(() => {
        const fetchUserScore = async () => {
            if (!userId) {
                console.error("Greška: userId je null ili nije postavljen.");
                return;
            }
            try {
                const scoreResponse = await API.get(`/module/score/${userId}`);
                const userScore = scoreResponse.data[0]?.score || 0;

                setUserData((prevData) => ({
                    ...prevData,
                    score: userScore,
                }));
            } catch (error) {
                console.error("Greška pri dohvaćanju score-a:", error);
            }
        };

        if (userId) {
            fetchUserScore();
        }
    }, [userId]);

    useEffect(() => {
        const startDate = new Date("2025-12-12"); // Postavi početni datum
        const currentDate = new Date(); // Trenutni datum

        // Izračunaj razliku u danima samo jednom prilikom mountanja komponente
        const timeDifference = startDate - currentDate; // Razlika u milisekundama
        const daysRemaining = Math.floor(timeDifference / (1000 * 3600 * 24)); // Pretvori u dane

        setUserData((prevData) => ({
            ...prevData,
            days: daysRemaining, // Postavi preostale dane
        }));
    }, []); // Ovaj useEffect se pokreće samo pri mountanju komponente

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login");
    };

    useEffect(() => {
        // Dohvatanje vrijednosti modula
        const fetchModuleData = async () => {
            try {
                const response = await API.get("/module/16"); // Prilagodi rutu prema backendu
                setMaxScore(response.data[0]?.max_number_points || 0);
            } catch (error) {
                console.error("Greška pri dohvaćanju modula:", error);
            }
        };

        // Dohvatanje korisničkih podataka
        const fetchUserData = async () => {
            const token = localStorage.getItem("token");
            if (!token) {
                console.error("Token nije pronađen, preusmjeravanje na login...");
                navigate("/login");
                return;
            }

            try {
                const response = await API.get("/user/userD"); // Ispravljena ruta
                const data = response.data?.data?.[0];

                if (!data) {
                    console.error("Greška: Nema podataka o korisniku");
                    return;
                }

                setUserData((prevData) => ({
                    ...prevData,
                    first_name: data?.first_name || "N/A",
                    last_name: data?.last_name || "N/A",
                    username: data?.username || "N/A",
                    rank: data?.rank || 4,
                    completion: data?.completion || "10%",
                }));
            } catch (error) {
                console.error("Greška pri dohvaćanju korisničkih podataka:", error);
            }
        };

        fetchModuleData();
        fetchUserData();

        // Dohvati SEKCION I SCREEN za Malware modul
        API.get(`module/getModuleInfo/16`)
            .then((response) => {
                setSectionId(response.data[0]?.section_id || 1);
                setScreenId(response.data[0]?.screen_id || 1);
            });

        // Dohvati MAX BROJ SEKCIJA za malware modul
        API.get(`module/getMaxNumOfSections/16`)
            .then((response) => {
                setMaxSectionsNum(response.data);
            });
    }, []);

    return (
        <div className="dashboard-container">
            <div className="main-content2">
                <div className="email-prevare-content">
                    <img src={logo} alt="Cyber Awareness Logo" className="email-prevare-logo" />
                    <h2 className="module-title">CYBER AWARENESS TRAINING CENTRE</h2>
                    <h2 className="module-title">CYBER AWARENESS - BUSINESS</h2>

                    <p className="module-description">
                         "Postoje samo dva tipa kompanija; oni koji su bili hakirani, i oni koji će tek biti. Čak i to možemo spojiti u jednu kategoriju onih koji su bili i bit će opet"

Robert Mueller, Former FBI Director"
                    </p>

                    <p className="module-score">VRIJEDNOST MODULA - {maxScore} XP</p>

                    <button className="start-lesson-btn" onClick={() => navigate("/business-free", {
                        state: {
                            score: maxScore,
                            module_id: 16,
                            section_id: sectionId,
                            screen_id: screenId,
                            screenCounter: 1,
                            sectionCounter: 1,
                            scorePerQuestion: maxScore / maxSectionsNum,
                            numberOfTrys: 0,
                            
                        }
                    })}>
                        START LESSON
                    </button>
                </div>

            </div>

            <div className="sidebar">
                <div className="profile">
                    <img src={profile} alt="Profile" className="profile-img" />
                    <h4>{userData.first_name} {userData.last_name}</h4>
                    <p>@{userData.username}</p>
                </div>
                <div className="profile-info">
                    <div className="profile-info-header">
                        <h4>Profile Info</h4>
                        <p className="see-all">See All</p>
                    </div>
                    <div className="info-item"><span>🏆 Rank:</span> {userData.rank}</div>
                    <div className="info-item"><span>💡 Total score:</span> {userData.score}</div>
                    <div className="info-item"><span>❌ Completion:</span> {userData.completion}</div>
                    <div className="info-item"><span>📅 Days:</span> {userData.days}</div>
                </div>
                <div className="logout-container">
                    <button onClick={handleLogout} className="logout-btn">Log out</button>
                </div>
            </div>
        </div>
    );
};

export default CyberAwarenessBusinessIntro;